<template>
  <v-layout column>
    <v-flex
      v-if="
        tender && tender.contracts && tender.contracts.length && ['active.awarded', 'complete'].includes(tender.status)
      "
      class="accordion"
      key="contract"
      :class="{ 'elevation-10': tender.status === 'active.awarded' }"
    >
      <v-icon
        @click="openInformationDetail('Contract')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2
        @click="openInformationDetail('Contract')"
        class="cursor-pointer"
        title="More"
        v-translate
      >
        Contract
      </h2>
      <v-row v-for="(contract, i) in tender.contracts" :key="i">
        <v-col md="3">
          <p v-translate>Date signed</p>
          <span v-if="contract.dateSigned">
            {{ contract.dateSigned | moment('DD MMM YYYY') }}
          </span>
          <span v-else> N/A </span>
        </v-col>
        <v-col md="3" v-if="contract.value.amount && contract.value.currency">
          <p v-translate>Value</p>
          <span>
            {{ getFormatedValue(contract.value.amount, contract.value.currency) }}
          </span>
        </v-col>
        <v-col md="6">
          <p v-translate>Contract period</p>
          <span v-if="contract.period && contract.period.startDate && contract.period.endDate">
            {{ getRanges(contract.period.startDate, contract.period.endDate).startDate }}
            /
            {{ getRanges(contract.period.startDate, contract.period.endDate).endDate }}
          </span>
          <span v-else> N/A </span>
        </v-col>
        <v-col
          md="12"
          class="mt-4 d-flex justify-center"
          v-if="tender && tender.contracts && tender.contracts.length && tender.status === 'active.awarded'"
        >
          <v-btn
            @click="openInformationDetail('Contract')"
            min-height="40"
            min-width="200"
            class="ma-auto mb-4"
            color="primary"
          >
            <translate class="white--text">Add contract now</translate>
          </v-btn>
        </v-col>
      </v-row>
    </v-flex>
    <v-flex
      key="award"
      v-if="tender && tender.awards && tender.awards.length && awardShown"
      class="accordion"
      :class="{ 'elevation-10': tender.status === 'active.qualification' }"
    >
      <v-icon
        @click="openInformationDetail('Tender awards')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2 @click="openInformationDetail('Tender awards')" class="cursor-pointer" title="More">
        <translate tag="h2">Awarding</translate>
      </h2>
      <v-row v-for="(award, i) in tender.awards" :key="i">
        <v-col md="8">
          <p v-translate>
            {{ tender.status === 'active.qualification' ? 'Candidate' : 'Awarded Supplier' }}
          </p>
          <span v-for="(supplier, s) in award.suppliers" :key="s">
            {{ supplier.name }}
          </span>
        </v-col>
        <v-col md="4">
          <p v-translate>
            {{ tender.status === 'active.qualification' ? 'Candidate Bid Value' : 'Award Value' }}
          </p>
          <span>
            {{ getFormatedValue(award.value.amount, award.value.currency) }}
          </span>
        </v-col>
        <v-col md="12" class="mt-4 d-flex justify-center" v-if="award.status === 'pending'">
          <!-- <v-btn @click="openInformationDetail('Tender awards')" color="primary"
                        class="ma-auto mb-4 mr-4">
                        <translate style="color: #ffffff;">Award</translate>
                    </v-btn> -->
          <v-btn
            @click="openInformationDetail('Tender awards')"
            min-height="40"
            min-width="200"
            class="ma-auto mb-4"
            color="primary"
          >
            <translate class="white--text">Choose A Winner Now</translate>
          </v-btn>
        </v-col>
      </v-row>
    </v-flex>

    <v-flex
      v-if="checkSubmittingStatus"
      class="accordion"
      key="submit"
      :class="{ 'elevation-10': tender.status === 'active.tendering' }"
    >
      <v-icon
        @click="openInformationDetail('Submit a bid')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2
        @click="openInformationDetail('Submit a bid')"
        class="cursor-pointer"
        title="More"
        v-translate
      >
        Submit a bid
      </h2>
      <v-layout justify-space-between class="mt-4" wrap>
        <v-flex xs12 sm4>
          <p v-translate>Bid</p>
          <span v-if="tender.value">
            {{ getFormatedValue(bidValue, tender.value.currency) }}
          </span>
        </v-flex>
        <!-- <v-flex xs12 sm4 :style="{marginTop: $vuetify.breakpoint.xsOnly ? '1rem' : ''}">
                    <p v-translate>Documents</p>
                    <span>{{ submittedDocs }} <translate>document{{submittedDocs > 1? 's': ''}}</translate>
                    </span>
                </v-flex>
                <v-flex xs12 sm4 :style="{marginTop: $vuetify.breakpoint.xsOnly ? '1rem' : ''}"
                    v-if="languagesInDocs.length">
                    <p v-translate>Language</p>
                    <span>{{ languagesInDocs.join(', ')}}</span>
                </v-flex> -->
      </v-layout>
      <v-layout justify-space-between class="mt-4">
        <v-btn
          v-if="!isSubmitted"
          @click="openInformationDetail('Submit a bid')"
          color="primary"
          height="40"
          min-width="200"
          class="ma-auto mb-4"
        >
          <translate style="color: #ffffff">SUBMIT A BID now</translate>
        </v-btn>
      </v-layout>
    </v-flex>
    <v-flex v-if="isBidsShown" class="accordion" :key="Date.now()">
      <v-icon
        @click="openInformationDetail('Submitted bids')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2
        @click="openInformationDetail('Submitted bids')"
        class="cursor-pointer"
        title="More"
        v-translate
      >
        Submitted Bids
      </h2>
      <v-layout justify-space-between class="mt-4 deadline-block" wrap>
        <v-flex class="mb-4" v-if="formattedDeadlines.bidSubmission">
          <p v-translate>Number of Bids submitted</p>
          <span>{{ numberOfBidsSubmitted }}</span>
        </v-flex>
        <v-flex class="mb-4">
          <p>
            <translate tag="p">Value of Bid</translate>
          </p>
          <span v-if="valueOfTheBids">{{
            valueOfTheBids.min | moneyFormat(valueOfTheBids.currency)
          }}</span
          ><span class="mx-1" style="font-size: 1.2rem">-</span
          ><span v-if="valueOfTheBids">{{
            valueOfTheBids.max | moneyFormat(valueOfTheBids.currency)
          }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="$route.path.includes('bids-tenders')" class="accordion">
      <v-icon
        @click="openInformationDetail('Submitted bids')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2
        @click="openInformationDetail('Submitted bids')"
        class="cursor-pointer"
        title="More"
        v-translate
      >
        My Bid
      </h2>
      <v-layout justify-space-between class="mt-4 deadline-block" wrap>
        <!-- <v-flex class="mb-4" v-if="formattedDeadlines.bidSubmission">
                    <p v-translate>Number of Bids submitted</p>
                    <span>{{numberOfBidsSubmitted}}</span>
                </v-flex> -->
        <v-flex class="mb-4">
          <p>
            <translate tag="p">Bid Value</translate>
          </p>
          <span v-if="tender && tender.bids && tender.bids[0]">{{
            tender.bids[0].value.amount | moneyFormat(tender.bids[0].value.currency)
          }}</span>
          <!-- <span v-if="valueOfTheBids">{{valueOfTheBids.min | moneyFormat(valueOfTheBids.currency)}}</span><span class="mx-1" style="font-size: 1.2rem;">-</span><span v-if="valueOfTheBids">{{valueOfTheBids.max | moneyFormat(valueOfTheBids.currency)}}</span> -->
        </v-flex>
        <v-flex class="mb-4">
          <v-btn
            @click="getBidButtonFunction"
            v-if="
              tender &&
              tender.bids &&
              tender.bids[0] &&
              parseInt(tender.bids[0].value.amount) > 0 &&
              ['active', 'draft'].includes(tender.bids[0].status)
            "
            color="primary"
          >
            <translate style="color: #ffffff">{{
              getBidSubmissionButtonName(tender.bids[0].status)
            }}</translate>
          </v-btn>
        </v-flex>
        <v-flex>
          <v-layout justify-end>
            <v-dialog v-model="editBidDialog" max-width="500px" persistent>
              <v-card>
                <v-card-title class="pb-0">
                  <span class="headline" v-translate>Edit Bid</span>
                </v-card-title>
                <ErrorMessages :error="error" class="pl-4" />
                <v-card-text class="py-0">
                  <v-container grid-list-md class="pa-0">
                    <v-form ref="form">
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field
                            v-model="bidValue"
                            :rules="[(v) => !!v || 'This field is required']"
                            required
                            :label="$gettext('Bid') + ' *'"
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="editBidDialog = false"
                    ><translate>Cancel</translate></v-btn
                  >
                  <v-btn color="blue darken-1" text @click="updateBid"
                    ><translate>Update</translate></v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="tender && tender.tenderPeriod" class="accordion" key="deadlines">
      <v-icon
        @click="openInformationDetail('Deadlines')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2
        @click="openInformationDetail('Deadlines')"
        class="cursor-pointer"
        title="More"
        v-translate
      >
        Deadlines
      </h2>
      <v-layout justify-space-between class="mt-4 deadline-block" wrap>
        <v-flex class="mb-4" v-if="formattedDeadlines.bidSubmission">
          <p v-translate>Bid Submission Deadline</p>
          <span>{{ formattedDeadlines.bidSubmission }}</span>
        </v-flex>
        <v-flex class="mb-4" v-if="formattedDeadlines.qa">
          <p>
            <translate tag="p">Q&A Deadline</translate>
          </p>
          <span>{{ formattedDeadlines.qa }}</span>
        </v-flex>
        <v-flex class="mb-4" v-if="formattedDeadlines.notice">
          <p>
            <translate tag="p">Tender Notice Update Deadline</translate>
          </p>
          <span>{{ formattedDeadlines.notice }}</span>
        </v-flex>
        <v-flex class="mb-4" v-if="formattedDeadlines.complaint">
          <p>
            <translate tag="p">Complaint Submission Deadline</translate>
          </p>
          <span>{{ formattedDeadlines.complaint }}</span>
        </v-flex>
        <v-flex class="mb-4" v-if="formattedDeadlines.award">
          <p>
            <translate tag="p">Awarding Deadline</translate>
          </p>
          <span>{{ formattedDeadlines.award }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex class="accordion" key="items">
      <v-icon
        @click="openInformationDetail('Items')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2 @click="openInformationDetail('Items')" class="cursor-pointer" title="More" v-translate>
        Items
      </h2>
      <v-layout v-if="tender && tender.items && tender.items[0]" column class="mt-4">
        <v-layout wrap>
          <v-flex xs12 sm7>
            <p>
              <translate tag="p"> Classification (scheme) </translate>
            </p>
            <span v-for="(clas, i) in generalizedClassificator" :key="i" class="d-block">
              {{ clas }}
            </span>
          </v-flex>
          <v-flex
            xs12
            sm5
            v-if="tender.items[0].unit"
            :style="{ marginTop: $vuetify.breakpoint.xsOnly ? '1rem' : '' }"
          >
            <p v-translate>Quantity</p>
            <span v-for="(itemQuant, i) in formattedQuantity" :key="i">{{ itemQuant }}</span>
          </v-flex>
        </v-layout>
        <v-layout v-if="tender.items && tender.items[0].unit" class="mt-4" wrap>
          <v-flex xs12 sm7>
            <p class="mt-4" v-translate>Delivery Period</p>
            <span v-if="tender.items && tender.items[0].deliveryDate">
              {{ deliveryPeriod.startDate || ''
              }}{{ deliveryPeriod.startDate && deliveryPeriod.endDate ? ' - ' : ''
              }}{{ deliveryPeriod.endDate || '' }}
            </span>
          </v-flex>
          <v-flex xs12 sm5>
            <p class="mt-4" v-translate>Delivery Location</p>
            <span>{{ itemDeliveryLocation }}</span>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
    <v-flex class="accordion" key="document" v-if="isTenderDocumentsShown">
      <v-icon
        @click="openInformationDetail('Documents')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2
        @click="openInformationDetail('Documents')"
        class="cursor-pointer"
        title="More"
        v-translate
      >
        Documents
      </h2>
      <v-layout justify-space-between class="mt-4">
        <v-flex class="mr-2">
          <p v-translate>Number of documents added</p>
          <span>{{ (tender.documents && tender.documents.length) || 0 }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex class="accordion" key="author">
      <v-icon
        @click="openInformationDetail('Contracting Authority information')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2
        @click="openInformationDetail('Contracting Authority information')"
        class="cursor-pointer"
        title="More"
        v-translate
      >
        Contracting Authority information
      </h2>
      <v-row v-if="tender" justify-space-between class="mt-4">
        <v-col cols="12" sm="4" v-if="tender.procuringEntity && tender.procuringEntity.id">
          <p>
            <translate tag="p"> ID </translate>
          </p>
          <span style="overflow-wrap: break-word">
            {{
              tender.procuringEntity &&
              tender.procuringEntity.id &&
              tender.procuringEntity.id.match(/\d{8}/gi)[0]
            }}
          </span>
        </v-col>
        <v-col cols="12" sm="4" :style="{ marginTop: $vuetify.breakpoint.xsOnly ? '1rem' : '' }">
          <p v-translate>Legal name</p>
          <span>
            {{
              (tender.procuringEntity &&
                tender.procuringEntity.identifier &&
                tender.procuringEntity.identifier.legalName) ||
              ($store.state.auth.orgInfo && $store.state.auth.orgInfo.name)
            }}
          </span>
        </v-col>
        <v-col cols="12" sm="4" :style="{ marginTop: $vuetify.breakpoint.xsOnly ? '1rem' : '' }">
          <p v-translate>Contact Point</p>
          <span>
            {{
              tender.procuringEntity &&
              tender.procuringEntity.contactPoint &&
              tender.procuringEntity.contactPoint.name +
                ', ' +
                tender.procuringEntity.contactPoint.telephone
            }}
          </span>
        </v-col>
      </v-row>
    </v-flex>
    <v-flex class="accordion" key="details">
      <v-icon
        @click="openInformationDetail('Tender details')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2
        @click="openInformationDetail('Tender details')"
        class="cursor-pointer"
        title="More"
        v-translate
      >
        Tender details
      </h2>
      <v-layout v-if="tender" justify-space-between class="mt-4" wrap>
        <v-flex xs12 sm4>
          <p v-translate>Tender ID</p>
          <span v-if="tender.tenderID">
            {{ tender.tenderID }}
          </span>

          <v-tooltip top open-on-hover max-width="300px" color="info" v-else>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="#c3c3c3" class="mr-2" size="20"
                >mdi-information-outline</v-icon
              >
            </template>
            <p class="mb-0">Tender ID is assigned after the tender publication.</p>
          </v-tooltip>
        </v-flex>
        <v-flex
          xs12
          sm4
          :style="{ marginTop: $vuetify.breakpoint.xsOnly ? '1rem' : '' }"
          v-if="formattedStatus"
        >
          <p v-translate>Tender proceeding status</p>
          <v-tooltip top open-on-hover max-width="300px" color="info">
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="formattedStatus === 'error'"
                v-on="on"
                color="#c3c3c3"
                class="mr-2"
                size="20"
                >mdi-information-outline</v-icon
              >
            </template>
            <span v-if="tender && tender.errorMessage">{{ tender.errorMessage }}</span>
          </v-tooltip>
          <span>{{ formattedStatus }}</span>
        </v-flex>
        <v-flex
          v-if="tender.value && tender.value.amount"
          xs12
          sm4
          :style="{ marginTop: $vuetify.breakpoint.xsOnly ? '1rem' : '' }"
        >
          <p v-translate>Estimated value of procurement</p>
          <span>{{ getFormatedValue(tender.value.amount, tender.value.currency) }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex class="accordion" v-if="tender && tender.lots" key="lots">
      <v-icon
        @click="openInformationDetail('Lots')"
        class="open-accordion cursor-pointer"
        title="More"
        large
      >
        keyboard_arrow_down
      </v-icon>
      <h2 @click="openInformationDetail('Lots')" class="cursor-pointer" title="More">Lots</h2>
      <v-layout v-if="tender.lots && tender.lots[0]" justify-space-between class="mt-4">
        <v-flex class="mr-2">
          <p>ID</p>
          <span>{{ tender.lots[0].id }}</span>
        </v-flex>
        <v-flex>
          <p>Title</p>
          <span>{{ tender.lots[0].title }}</span>
        </v-flex>
        <v-flex v-if="tender.lots[0] && tender.lots[0].value.amount">
          <p>Amount</p>
          <span>{{ tender.lots[0].value.amount }}</span>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import GlobalFunctions from '@/utils/GlobalFunctions'
import tenderStatusMapping from '@/assets/mappings/tenderStatusMapping'
import BidApi from '@/services/apiCalls/bids'
import ErrorHandler from '@/utils/ErrorHandler'
import subscriptions from '@/services/apiCalls/subscriptions'

export default {
  name: 'TenderDetailFieldsBlock',

  props: {
    tender: {
      type: null,
      required: true,
    },
    openInformationDetail: {
      type: Function,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    getTender: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      submittedDocs: 0,
      languagesInDocs: 0,
      bidValue: 0,
      isSubmitted: false,
      editBidDialog: false,
      error: '',
    }
  },

  watch: {
    editBidDialog() {
      if (this.tender && this.tender.bids && this.tender.bids[0]) {
        this.bidValue = this.tender.bids[0].value && this.tender.bids[0].value.amount
      }
    },

    tender: {
      handler(v) {
        if (v) {
          this.subscribeOnBidChanges();
        }
      },
      immediate: true,
    }
  },

  computed: {
    isTenderDocumentsShown() {
      return this.tender;
      // if(this.tender) {
      //     if(this.type === 'myTenders') {
      //         return true
      //     } else if(this.type === 'publicTenders') {
      //         if(this.tender.status !== 'draft') {
      //             return true
      //         } else {
      //             return false
      //         }
      //     } else if(this.type === 'myBidsTender'){
      //        if(this.tender.status !== 'draft') {
      //            return true
      //        } else {
      //            return false
      //        }
      //     } else {
      //         return false
      //     }
      // } else {
      //     return false
      // }
    },
    awardShown() {
      const statuses = [
        'complete',
        'active.qualification',
        'active.awarded',
        'unsuccessful',
        'cancelled',
      ]

      return (
        this.tender &&
        statuses.includes(this.tender.status) &&
        this.$route.path.includes('my-tenders')
      )
    },
    isBidsShown() {
      const statuses = [
        'complete',
        'active.qualification',
        'active.awarded',
        'unsuccessful',
        'cancelled',
      ]
      return (
        this.tender &&
        statuses.includes(this.tender.status) &&
        this.tender.bids &&
        this.tender.bids.length &&
        !this.$route.path.includes('bids-tenders')
      )
    },
    numberOfBidsSubmitted() {
      if (this.tender && this.tender.bids) {
        return this.tender.bids.length
      }
      return null
    },
    valueOfTheBids() {
      if (this.tender && this.tender.bids && this.tender.bids.length) {
        const values = this.tender.bids.map((el) => el.value.amount)

        const minValue = Math.min(...values)
        const maxValue = Math.max(...values)

        return {
          min: minValue,
          max: maxValue,
          currency: this.tender.bids[0].value.currency,
        }
      }
    },
    checkSubmittingStatus() {
      // const nowDate = new Date().getTime()
      // console.log("ddd",Date.parse(this.tender.tenderPeriod.endDate))
      if (
        this.tender &&
        this.tender.status === 'active.tendering' &&
        this.type !== 'prozorroTenders' &&
        this.type !== 'myTenders' &&
        !this.$route.path.includes('bids-tenders')
        // &&
        // (this.tender.tenderPeriod.startDate &&
        //     Date.parse(this.tender.tenderPeriod.startDate) <
        //         nowDate) &&
        // (this.tender.tenderPeriod.endDate &&
        // Date.parse(this.tender.tenderPeriod.endDate) > nowDate)
      ) {
        return true
      } else {
        return false
      }
    },
    itemDeliveryLocation() {
      if (this.tender && this.tender.items && this.tender.items[0].deliveryAddress) {
        let address = this.tender.items[0].deliveryAddress

        let property = this.findPropertyForLocation(this.tender.items)

        if (this.tender.items.length > 1) {
          return `${this.tender.items.length} different delivery location in
                        ${address[property]}, ${address.countryName}`
        } else {
          return `${address.countryName || ''}${
            address.countryName && address.region ? ', ' : ''
          } ${address.region || ''}${address.region && address.locality ? ', ' : ''}
                            ${address.locality || ''}${
            address.locality && address.streetAddress ? ', ' : ''
          }${address.streetAddress || ''}${
            address.streetAddress && address.postalCode ? ', ' : ''
          }${address.postalCode || ''}`
        }
      } else {
        return '-----'
      }
    },
    deliveryPeriod() {
      if (this.tender && this.tender.items) {
        let startDate = null
        let endDate = 0

        this.tender.items.forEach((item) => {
          if (!startDate) startDate = Date.parse(item.deliveryDate.startDate)
          else {
            startDate = Math.min(startDate, Date.parse(item.deliveryDate.startDate))
          }

          endDate = Math.max(endDate, Date.parse(item.deliveryDate.endDate))
        })

        if ((!startDate && endDate) || (!endDate && startDate)) {
          return {
            startDate: (startDate && Vue.moment(startDate).format('DD MMM YYYY')) || null,
            endDate: (endDate && Vue.moment(endDate).format('DD MMM YYYY')) || null,
          }
        }

        if (!startDate && !endDate) {
          return {
            startDate: '-',
            endDate: '-',
          }
        }

        let startMonth = Vue.moment(startDate).month()
        let endMonth = Vue.moment(endDate).month()

        let startYear = Vue.moment(startDate).year()
        let endYear = Vue.moment(endDate).year()

        if (startMonth === endMonth && startYear === endYear) {
          startDate = Vue.moment(startDate).format('DD')
          endDate = Vue.moment(endDate).format('DD MMM YYYY')
        } else if (startYear !== endYear) {
          startDate = Vue.moment(startDate).format('YYYY')
          endDate = Vue.moment(endDate).format('YYYY')
        } else {
          startDate = Vue.moment(startDate).format('MMM')
          endDate = Vue.moment(endDate).format('MMM YYYY')
        }

        return {
          startDate,
          endDate,
        }
      }
      return {
        startDate: '-',
        endDate: '-',
      }
    },
    generalizedClassificator() {
      if (this.tender && this.tender.items) {
        let classesByCpv = {}
        let classes = []
        let cpvs = this.$store.state.i18n.translations[this.$store.state.i18n.locale]

        if (this.tender.items.length === 1) {
          classes.push(
            `1 class of ${cpvs[`cpv.${this.tender.items[0].classification.id}`]} (${
              this.tender.items[0].classification.id
            })`,
          )
        } else {
          this.tender.items.forEach((item) => {
            let cpv = item.classification.id

            if (cpv in classesByCpv) {
              classesByCpv[cpv].number++
            } else if (Object.keys(classesByCpv).some((key) => key.startsWith(cpv.slice(0, 3)))) {
              let property = Object.keys(classesByCpv).find((property) =>
                property.startsWith(cpv.slice(0, 3)),
              )
              classesByCpv[property].similarClassNumber++
              classesByCpv[property].cpvSlice = cpv.slice(0, 3)
            } else {
              classesByCpv[cpv] = {
                number: 1,
                similarClassNumber: 0,
                cpvSlice: '',
              }
            }
          })

          let cpvObjectKeys = Object.keys(classesByCpv)
          let cpvKeys = Object.keys(cpvs)

          for (let key of cpvObjectKeys) {
            if (classesByCpv[key].similarClassNumber === 0) {
              classes.push(
                `${classesByCpv[key].number} ${
                  classesByCpv[key].number > 1 ? 'classes' : 'class'
                } of ${cpvs[`cpv.${key}`]} (${key})`,
              )
            } else {
              for (let cpvKey of cpvKeys) {
                cpvKey = cpvKey.replace(/cpv\./, '')

                if (cpvKey.startsWith(classesByCpv[key].cpvSlice) && /\d{3}00000-\d/.test(cpvKey)) {
                  classes.push(
                    `${
                      classesByCpv[key].similarClassNumber + classesByCpv[key].number
                    } classes of ${cpvs[`cpv.${cpvKey}`]} (${cpvKey})`,
                  )
                }
              }
            }
          }
        }

        return classes
      }
      return ''
    },
    formattedQuantity() {
      if (!this.tender && !this.tender.items) return null
      const units = {}

      for (let item of this.tender.items) {
        let unit = item.unit && (item.unit.name || item.unit)

        if (!units[unit]) {
          units[unit] = +item.quantity
        } else {
          units[unit] += +item.quantity
        }
      }

      return Object.keys(units).map((unitKey, i) => {
        return `${units[unitKey]} ${unitKey}${i < Object.keys(units).length - 1 ? ', ' : ''}`
      })
    },
    formattedStatus() {
      if (!this.tender) return '?'
      let status = this.tender.status || '?'

      return tenderStatusMapping[status]
    },
    formattedDeadlines() {
      if (this.tender && this.tender.tenderPeriod) {
        return {
          qa:
            (this.tender.enquiryPeriod &&
              this.tender.enquiryPeriod.endDate &&
              Vue.moment(this.tender.enquiryPeriod.endDate).format('DD MMM YYYY')) ||
            null,
          notice:
            (this.tender.tenderPeriod &&
              this.tender.tenderPeriod.notice &&
              Vue.moment(this.tender.tenderPeriod.notice).format('DD MMM YYYY')) ||
            null,
          complaint:
            (this.tender.tenderPeriod &&
              this.tender.tenderPeriod.complaint &&
              Vue.moment(this.tender.tenderPeriod.complaint).format('DD MMM YYYY')) ||
            null,
          award:
            (this.tender.awardPeriod &&
              this.tender.awardPeriod.endDate &&
              Vue.moment(this.tender.awardPeriod.endDate).format('DD MMM YYYY')) ||
            null,
          bidSubmission:
            (this.tender.tenderPeriod &&
              this.tender.tenderPeriod.endDate &&
              Vue.moment(this.tender.tenderPeriod.endDate).format('DD MMM YYYY HH:mm:ss')) ||
            null,
        }
      }
      return {
        qa: '',
        notice: '',
        complaint: '',
        award: '',
        bidSubmission: '',
      }
    },
  },

  methods: {
    subscribeOnBidChanges() {
      if (this.tender.bids && this.tender.bids[0] && this.tender.bids[0].mpID) {
        const subscription = subscriptions.onBidChanged(this.tender.bids[0].mpID)
        .subscribe({
          next: ({ status }) => {
            this.tender.bids[0].status = status;
          },
          error: error => console.error(error),
        });
        this.$once('hook:beforeDestroy', () => {
          subscription.unsubscribe();
        });
      }
    },

    getRanges(startDate, endDate) {
      startDate = Date.parse(startDate)
      endDate = Date.parse(endDate)

      if ((!startDate && endDate) || (!endDate && startDate)) {
        return {
          startDate: (startDate && Vue.moment(startDate).format('DD MMM YYYY')) || null,
          endDate: (endDate && Vue.moment(endDate).format('DD MMM YYYY')) || null,
        }
      }

      if (!startDate && !endDate) {
        return {
          startDate: '-',
          endDate: '-',
        }
      }

      let startMonth = Vue.moment(startDate).month()
      let endMonth = Vue.moment(endDate).month()

      let startYear = Vue.moment(startDate).year()
      let endYear = Vue.moment(endDate).year()

      if (startMonth === endMonth && startYear === endYear) {
        startDate = Vue.moment(startDate).format('DD')
        endDate = Vue.moment(endDate).format('DD MMM YYYY')
      } else if (startYear !== endYear) {
        startDate = Vue.moment(startDate).format('YYYY')
        endDate = Vue.moment(endDate).format('YYYY')
      } else {
        startDate = Vue.moment(startDate).format('MMM')
        endDate = Vue.moment(endDate).format('MMM YYYY')
      }

      return {
        startDate,
        endDate,
      }
    },
    findPropertyForLocation(items) {
      let adressProperties = Object.keys(items[0].deliveryAddress)

      let calcProperty = ''

      if (items.length < 2) return 'region'

      for (let property of adressProperties) {
        //we need to find out if each item property value differs between other values
        //if it's the case then this property will be returned

        let propertyEquality = items.every((item, i) => {
          //here we check if item with chosen property is
          //not equal to other items with the same property

          let isItemNotEqual = items.slice(i).every((anotherItem, j) => {
            if (i === j) return true
            if (item.deliveryAddress[property] !== anotherItem.deliveryAddress[property]) {
              return true
            } else {
              return false
            }
          })

          return isItemNotEqual || false
        })

        //if item with chosen property is not equal to each other
        //so we can return found property and break loop

        if (propertyEquality) {
          calcProperty = property
          break
        }
      }
      if (!calcProperty) return 'region'
    },
    getFormatedValue(value, currency) {
      return GlobalFunctions.toNumberFormat(value, currency)
    },
    getBidSubmissionButtonName(bidStatus) {
      const BUTTON_NAMES = {
        active: 'EDIT BID',
        draft: 'SUBMIT A BID NOW',
      }
      return BUTTON_NAMES[bidStatus]
    },
    getBidButtonFunction() {
      const bidStatus = this.tender.bids[0].status
      if (bidStatus === 'draft') {
        this.saveBid()
      } else if (bidStatus === 'active') {
        this.editBidDialog = true
      }
    },
    async saveBid() {
      try {
        this.$store.commit('spinner', true)
        await BidApi.publishBid(this.$route.params.id)

        this.$store.commit('openSnackBar', {
          text: `The bid has been sent for submission`,
          color: 'success',
        })
        this.$store.commit('spinner', false)
        await this.getTender()
      } catch (err) {
        this.$store.commit('spinner', false)
        ErrorHandler(err, this)
      }
    },
    async updateBid() {
      if (!this.$refs.form.validate()) return
      this.$store.commit('spinner', true)
      this.error = ''
      const bidInformation = {
        mpID: this.$route.params.id,
        bid: {
          value: {
            amount: this.bidValue,
            currency: this.tender.value.currency,
          },
        },
      }
      try {
        await BidApi.updateBid(bidInformation)

        this.$store.commit('openSnackBar', {
          text: `The bid has been sent updated`,
          color: 'success',
        })

        this.$store.commit('spinner', false)
        this.editBidDialog = false
        await this.getTender()
      } catch (err) {
        console.error(err)
        this.$store.commit('spinner', false)
        this.error = (err && err.errors && err.errors[0] && err.errors[0].message) || err
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.accordion {
  padding: 10px 16px;
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 14px;
  position: relative;
}
h2 {
  font-size: 20px;
  color: grey;
  font-family: 'Montserrat', sans-serif;
}

.tender-detail-header {
  font-family: 'Ubuntu', sans-serif;
  line-height: 1.6rem;
}
.open-accordion {
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
}
.accordion p {
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 12.6px;
  margin-bottom: 6px;
}
.accordion span {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.61);
}
.accordion .text {
  font-size: 15px;
  color: dimgrey;
}

@media (max-width: 960px) {
  .right-box > div {
    margin-top: 40px;
    padding-left: 32px !important;
  }
}

@media (max-width: 600px) {
  .deadline-block {
    flex-direction: column !important;
  }
}
</style>
